const NotFound = () => {
    return <h1>No se encontro</h1>
}
export default NotFound;